import React from 'react';
import renderer from 'react-test-renderer';
import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';
import { plans, accountTypes, userLicenses } from '../../__mocks__/account-data';

import UserLicenses from '../../../admin/users/UserLicenses';
import api from '../../../../services/api';

global.fetch = jest.fn().mockResolvedValueOnce({ json: () => Promise.resolve({ }) });
api.admin.user_licenses.get = jest.fn().mockResolvedValue({
  status: 'OK',
  data: {
    user_licenses: userLicenses,
    totalCount: 1000,
    activeCount: 500,
    totalPages: 10,
    currentPage: 1,
  },
});

it('renders correctly with props', () => {
  const tree = renderer.create(<UserLicenses accountTypes={accountTypes} plans={plans} />).toJSON();
  expect(tree).toMatchSnapshot();
});

it('renders correctly without props', () => {
  const tree = renderer.create(<UserLicenses />).toJSON();
  expect(tree).toMatchSnapshot();
});

it('renders payments history with props', async () => {
  render(<UserLicenses accountTypes={accountTypes} plans={plans} />);
  const filtersButton = document.getElementsByClassName('filters-button ');
  expect(filtersButton.length).toBe(1);
  fireEvent.click(filtersButton[0]);
  const sort = await screen.findByText(/User Name/i);
  fireEvent.click(sort);
});
